import type { ReactNode } from "react";

export type PillTone = "success" | "warning" | "danger" | "info" | "neutral";

export function Pill({
  tone,
  children,
}: {
  tone: PillTone;
  children: ReactNode;
}) {
  return <span className={`pill pill--${tone}`}>{children}</span>;
}

export function Skeleton({
  width,
  kind = "line",
}: {
  width?: string | number;
  kind?: "line" | "title" | "row";
}) {
  const style = width ? { width } : undefined;
  return <span className={`skeleton skeleton--${kind}`} style={style} />;
}

export function TableSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div>
      <Skeleton kind="title" />
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} kind="row" />
      ))}
    </div>
  );
}
